import React from 'react'

export default function NoMatch() {
  return (
    <div>
      <h1>No Match</h1>
    </div>
  )
}
